import D1 from '../../components/ExcerciseTypes/Design/TypeIn';

const json = {
  1: { // Exercise num
    unit: 'Unit 6',
    id: 'WB3-U6-P40-E1',
    audio: '',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page40/E1/Key/answerKey.png',
    component: D1,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page40/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page40/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page40/E1/3.jpg', input: true, answer: "have breakfast" },
        { url: 'img/FriendsPlus/Page40/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page40/E1/5.jpg', input: true, answer: "go to school" },
        { url: 'img/FriendsPlus/Page40/E1/6.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page40/E1/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page40/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page40/E1/9.jpg', input: true, answer: "get up" },
        { url: 'img/FriendsPlus/Page40/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page40/E1/11.jpg', input: true, answer: "go home" },
        { url: 'img/FriendsPlus/Page40/E1/12.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page40/E1/13.jpg' },
      ],
    ],
  },
  2: { // Exercise num
    unit: 'Unit 6',
    id: 'WB3-U6-P40-E2',
    audio: '',
    video: '',
    component: D1,
    checkUppercase: true,
    exerciseKey: 'img/FriendsPlus/Page40/E2/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page40/E2/0.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page40/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page40/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page40/E2/3.jpg', input: true, answer: "I go home." },
        { url: 'img/FriendsPlus/Page40/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page40/E2/5.jpg', input: true, answer: "5" },
        { url: 'img/FriendsPlus/Page40/E2/6.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page40/E2/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page40/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page40/E2/9.jpg', input: true, answer: "I get up." },
        { url: 'img/FriendsPlus/Page40/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page40/E2/11.jpg', input: true, answer: "4" },
        { url: 'img/FriendsPlus/Page40/E2/12.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page40/E2/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page40/E2/14.jpg' },
        { url: 'img/FriendsPlus/Page40/E2/15.jpg', input: true, answer: "I have dinner." },
        { url: 'img/FriendsPlus/Page40/E2/16.jpg' },
        { url: 'img/FriendsPlus/Page40/E2/17.jpg', input: true, answer: "1" },
        { url: 'img/FriendsPlus/Page40/E2/18.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page40/E2/19.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page40/E2/20.jpg' },
        { url: 'img/FriendsPlus/Page40/E2/21.jpg', input: true, answer: "I have breakfast." },
        { url: 'img/FriendsPlus/Page40/E2/22.jpg' },
        { url: 'img/FriendsPlus/Page40/E2/23.jpg', input: true, answer: "2" },
        { url: 'img/FriendsPlus/Page40/E2/24.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page40/E2/25.jpg' },
      ],


    ],
  },




}

export default json;